"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var utils_1 = require("./utils");
var globals_1 = require("./globals");
var ua_parser_js_1 = require("ua-parser-js");
var TrackingStopped = /** @class */ (function (_super) {
    __extends(TrackingStopped, _super);
    function TrackingStopped() {
        var _this = this;
        var body = {
            device: "",
            user_agent: "",
            connection: "",
            id_type: globals_1.default.id_type,
            id_value: null,
            lang: "",
            os_version: "",
            is_refreshed: 0,
            query_string_params: {},
        };
        if (utils_1.default.isClient()) {
            var userAgent = new ua_parser_js_1.UAParser();
            var device = (userAgent.getDevice().vendor || userAgent.getDevice().model) ? userAgent.getDevice().vendor + " " + userAgent.getDevice().model : userAgent.getCPU().architecture ? 'pc' : 'unknown';
            var deviceId = void 0;
            if (!(deviceId = utils_1.default.getLocalStorage(utils_1.default.DEVICE_ID_KEY))) {
                utils_1.default.setLocalStorage(utils_1.default.DEVICE_ID_KEY, (deviceId = utils_1.default.uuidv4()), 0);
            }
            body = {
                device: device,
                user_agent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                connection: "",
                id_type: globals_1.default.id_type,
                id_value: deviceId,
                lang: navigator === null || navigator === void 0 ? void 0 : navigator.language,
                os_version: navigator === null || navigator === void 0 ? void 0 : navigator.platform,
                is_refreshed: 0,
                query_string_params: {},
            };
        }
        _this = _super.call(this, "trackingStopped", body) || this;
        _this.setQueryStringParams();
        return _this;
    }
    TrackingStopped.prototype.GetDevice = function () {
        return this.getEventBody().getJson().device;
    };
    ;
    TrackingStopped.prototype.GetUserAgent = function () {
        return this.getEventBody().getJson().user_agent;
    };
    ;
    TrackingStopped.prototype.GetConnection = function () {
        return this.getEventBody().getJson().connection;
    };
    ;
    TrackingStopped.prototype.SetConnection = function (connection) {
        this.getEventBody().getJson().connection = connection;
        return this;
    };
    ;
    TrackingStopped.prototype.GetIdType = function () {
        return this.getEventBody().getJson().id_type;
    };
    ;
    TrackingStopped.prototype.setQueryStringParams = function () {
        if (utils_1.default.isClient()) {
            this.getEventBody().getJson().query_string_params = utils_1.default.getQueryStringParams(window.location.search);
        }
        return this;
    };
    TrackingStopped.prototype.GetIdValue = function () {
        return this.getEventBody().getJson().id_value;
    };
    ;
    TrackingStopped.prototype.GetLang = function () {
        return this.getEventBody().getJson().lang;
    };
    ;
    TrackingStopped.prototype.GetOsVersion = function () {
        return this.getEventBody().getJson().os_version;
    };
    ;
    TrackingStopped.prototype.SetIsRefreshed = function (is_refreshed) {
        this.getEventBody().getJson().is_refreshed = is_refreshed;
        return this;
    };
    ;
    TrackingStopped.prototype.GetIsRefreshed = function () {
        return this.getEventBody().getJson().is_refreshed;
    };
    TrackingStopped.prototype._isPrefab = function () {
        return true;
    };
    return TrackingStopped;
}(event_1.default));
exports.default = TrackingStopped;
//# sourceMappingURL=trackingStopped.js.map